import { createFileRoute } from "@tanstack/react-router";
import Otp from "@/auth/otp";

export const Route = createFileRoute("/(root)/root-user/otp")({
  component: () => <Otp isSuperadmin={true} />,
});
